import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { exitDemo, isDemoMode } from '../../demo/core';

/** Market accent (DESIGN.md). */
const DEMO_ACCENT = '#2CB259';

/** Thin sticky bar shown on every page while the tab is in demo mode. */
const DemoBanner: React.FC = () => {
  const { t } = useTranslation();
  if (!isDemoMode()) return null;

  return (
    <Box
      role="status"
      sx={{
        position: 'sticky',
        // Below the fixed mobile app bar on phones, flush with the top elsewhere.
        top: { xs: 56, sm: 0 },
        zIndex: (theme) => theme.zIndex.appBar - 1,
        minHeight: 36,
        px: 2,
        py: 0.5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'wrap',
        gap: 1.5,
        bgcolor: DEMO_ACCENT,
        color: '#FFFFFF',
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 600, color: 'inherit' }}>
        {t('demo.banner')}
      </Typography>
      <Button
        size="small"
        variant="outlined"
        color="inherit"
        onClick={exitDemo}
        sx={{ py: 0.25, px: 1.5, borderRadius: '8px', borderColor: 'rgba(255, 255, 255, 0.7)' }}
      >
        {t('demo.exit')}
      </Button>
    </Box>
  );
};

export default DemoBanner;
